import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Image, Row } from "react-bootstrap";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import help from "../assets/Icon/help-58.png";
import humannews from "../assets/Icon/human-news.png";
import religion from "../assets/Icon/mosque-50.png";
import news from "../assets/Icon/news-50.png";
import place from "../assets/Icon/place-60(2).png";
import culture from "../assets/Icon/culture.png";
import trash from "../assets/Icon/trash.png";
import project from "../assets/Icon/project.png";
import sienticet from "../assets/Icon/sienticet.png";
import view from "../assets/Icon/view.png";
import helpdesk from "../assets/Icon/help-desk.png";
import cemetery from "../assets/Icon/cemetery.png";
import rules from "../assets/Icon/rules.png";
import user2 from "../assets/Icon/user2.png";
import electronic from "../assets/Icon/cloud-service.png";
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Slider from "./Slider";
import useCheckUser from "../custom-hooks/useCheckUser";
import { ToastContainer, toast } from "react-toastify";
import MunicipalityDataContext from "../helpers/MunicipalityDataContext";

const styles = {
  tabs: {
    background: "#fff",
  },
  slide: {
    padding: 15,
    minHeight: 100,
    color: "#fff",
  },
  slide1: {
    backgroundColor: "#FEA900",
  },
  slide2: {
    backgroundColor: "#B3DC4A",
  },
  slide3: {
    backgroundColor: "#6AC0FF",
  },
};

function Dashboard() {
  const [load, setLoad] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [seenFile, setSeenFile] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const axios = require("axios");
  const [searchParams, setSearchParams] = useSearchParams();
  const promptId1 = searchParams.get("code");
  const promptId2 = searchParams.get("state");
  const navigate = useNavigate();
  const municipalitiyData = useContext(MunicipalityDataContext); //this context is for determine witch municipality to use

  useEffect(() => {
    const Tap1 = JSON.parse(localStorage.getItem("Tab"));
    if (Tap1 && Tap1 != null) {
      const Tap1 = JSON.parse(localStorage.getItem("Tab"));
      setTabIndex(Tap1);
    }

    if (promptId1 !== null && promptId2 !== null) {
      setLoad(true);
      axios
        .get(`https://api.myamol.ir?code=${promptId1}&state=${promptId2}`)
        .then((res) => {
          setLoad(false);
          if (res.data.result === "true") {
            localStorage.setItem("user_codemeli", res.data.data.CodeMelli);
            localStorage.setItem("user_mobile", res.data.data.Mobile);
            localStorage.setItem("user_namefamily", res.data.data.Firstname);
            localStorage.setItem("UserId", res.data.data.Id);
            localStorage.setItem("user_profile", res.data.data.Profile);
            navigate("/");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  }, []);

  const handleChange = (event, value) => {
    setTabIndex(value);
    localStorage.setItem("Tab", value);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  const getTockenHandler = () => {
    if (UserID === null) {
      switch (municipalitiyData?.name) {
        case 'آمل': 
          window.open("https://esd.myamol.ir", "_blank");
          break;
        case 'رویان':
          window.open("https://app.royan.ir", "_blank");
          break;
        case 'محمودآباد':
          window.open("https://app.mahmoodabad.ir", "_blank");
          break;
        default:
          break;
      }
    } else {
      switch (municipalitiyData?.name) {
        case 'آمل':
          axios.post(apiUrl + "GenerateUserToken?UserId=" + UserID).then((res) => {
            if (res.data.result === "true") {
              window.open(`https://esd.myamol.ir?Usertoken=${res.data.data}`, '_blank');
            } else {
            }
          });
          break;
        case 'رویان':
          axios.post(apiUrl + "GenerateUserToken?UserId=" + UserID).then((res) => {
            if (res.data.result === "true") {
              window.open(`https://app.royan.ir?Usertoken=${res.data.data}`, '_blank')
              // window.location.replace(`http://localhost:3001/?Usertoken=${res.data.data}`)
            } else {
            }
          });
          break;
        case 'محمودآباد':
          axios.post(apiUrl + "GenerateUserToken?UserId=" + UserID).then((res) => {
            if (res.data.result === "true") {
              window.open(`https://app.mahmoodabad.ir?Usertoken=${res.data.data}`, '_blank')
            } else {
            }
          });
          break;
        default:
          break;
      }
    }
  };

  const getTockenZistmandHandler = () => {
    if (UserID === null) {
      switch (municipalitiyData?.name) {
        case 'آمل':
          window.open("https://zistmand.myamol.ir", "_blank");
          break;
        case 'رویان':
          break;
        case 'محمودآباد':
          break;
        default:
          break;
      }
    } else {
      switch (municipalitiyData?.name) {
        case 'آمل':
          axios
            .post(apiUrl + "GenerateUserToken?UserId=" + UserID)
            .then((res) => {
              if (res.data.result === "true") {
                 window.open(`https://zistmand.myamol.ir?Usertoken=${res.data.data}`,"_blank");
              } else {
              }
            });
          break;
        case 'رویان':
          break;
        case 'محمودآباد':
          break;
        default:
          break;
      }
    }
  };

  const getTockenKhadamatELCHandler = () => {
    if (UserID === null) {
      switch (municipalitiyData?.name) {
        case 'آمل':
          window.open("https://esup.amol.ir/Api_Security/v2/auth/login-by-sso-amol","_blank");
          break;
        case 'رویان':
          break;
        case 'محمودآباد':
          break;
        default:
          break;
      }
    } else {
      switch (municipalitiyData?.name) {
        case 'آمل':
          axios.post(apiUrl + "GenerateUserToken?UserId=" + UserID).then((res) => {
            if (res.data.result === "true") {
              window.open( `https://esup.amol.ir/Api_Security/v2/auth/login-by-sso-amol?Usertoken=${res.data.data}`,"_blank");
            } else {
            }
          });
          break;
        case 'رویان':
          break;
        case 'محمودآباد':
          break;
        default:
          break;
      }
    }
  };

  const virtualVisitHandler = () => {
    toast.error("این قسمت در آینده اضافه خواهد شد", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3000,
    });
  };

  return (
    <>
      <div>
        <Header />
        <main>
          <div className="pt-0 pt-lg-5">
            {/* {staticInfo.title}
          {staticInfo.background_image} */}

            <Container className="dashboard-tab">
              <Row className="justify-content-center mb-3">
                {/* <Col xs={12} style={{ direction: "ltr" }} className="d-block d-lg-none g-0">
                  <Slider />
                </Col> */}

                <Col xs={11} lg={8} className="g-0">
                  <div className="rgc-logo d-flex justify-content-center">
                    {/* <Image src={`${IPUrl}UploadedFile/Logo/Logo.png`} /> */}
                    <div className="rgc-logo-part  d-flex flex-column text-center justify-conent-center gap-3 mb-5 w-50">
                      <span>سامانه {municipalitiyData?.name} من</span>
                      <span>
                        خدمات آنلاین شهرداری {municipalitiyData?.name}
                      </span>

                      <form className="rgc-search mr-5 mt-5">
                        <input
                          className="form-control me-2 rgc-search"
                          type="search"
                          placeholder="جستجو..."
                          aria-label="Search"
                        />
                        <i className="fa-light fa-magnifying-glass"></i>
                        <i className="fa fa-search"></i>
                      </form>
                    </div>
                  </div>

                  <Tabs
                    value={tabIndex}
                    fullWidth
                    onChange={handleChange}
                    style={styles.tabs}
                  >
                    <Tab label="خدمات شهری" />
                    <Tab label="شهرسازی" />
                    <Tab label="اخبار " />
                    <Tab label="گردشگری" />
                  </Tabs>
                  <SwipeableViews
                    index={tabIndex}
                    onChangeIndex={handleChangeIndex}
                  >
                    {/* Services */}
                    <div style={Object.assign({}, styles.slide)}>
                      <Row className="justify-content-start">
                        <Col
                          xs={4}
                          lg={3}
                          className="sub-side mb-3"
                          onClick={getTockenHandler}
                        >
                          {/* <a href="https:\\esd.myamol.ir" target="_blank"> */}
                          <div className="rgc-card">
                            <div className="d-flex flex-column rgc-card-img">
                              <div className="rgc-icons">
                                <Image src={helpdesk} alt=".." fluid />
                              </div>

                              <div className="rgc-card-body">
                                <h6>میز خدمت </h6>
                              </div>
                            </div>
                          </div>
                          {/* </a> */}
                        </Col>

                        <Col
                          xs={4}
                          lg={3}
                          className="sub-side mb-3"
                          onClick={getTockenZistmandHandler}
                        >
                          {/* <a href="https:\\zistmand.myamol.ir" target="_blank"> */}
                          <div className="rgc-card">
                            <div className="d-flex flex-column rgc-card-img">
                              <div className="rgc-icons">
                                <Image src={trash} alt=".." fluid />
                              </div>

                              <div className="rgc-card-body">
                                <h6>پسماند</h6>
                              </div>
                            </div>
                          </div>
                          {/* </a> */}
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to="../cemetery">
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={cemetery} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>آرامستان</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to="../projects">
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={project} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>پروژه ها</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>
                      </Row>
                    </div>

                    {/* Building */}
                    <div style={Object.assign({}, styles.slide)}>
                      <Row className="justify-content-start">
                        <Col
                          xs={4}
                          lg={3}
                          className="sub-side mb-3"
                          onClick={getTockenKhadamatELCHandler}
                        >
                          {/* <a href="https://esup.amol.ir/citizen" target="_blank"> */}
                          <div className="rgc-card">
                            <div className="d-flex flex-column rgc-card-img">
                              <div className="rgc-icons">
                                <Image src={electronic} alt=".." fluid />
                              </div>

                              <div className="rgc-card-body">
                                <h6>خدمات الکترونیکی</h6>
                              </div>
                            </div>
                          </div>
                          {/* </a> */}
                        </Col>
                      </Row>
                    </div>

                    {/* News */}
                    <div style={Object.assign({}, styles.slide)}>
                      <Row className="justify-content-start">
                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to={`/${2}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={humannews} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>اخبار شهروندی</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to={`/${1}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={news} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>اخبار شهرداری</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to={`/${5}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={rules} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>مصوبات شورا</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to={`/${3}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={help} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>راهنمای شهروندی</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          {/* <animated.div style={style} onMouseEnter={trigger}> */}
                          <NavLink to="/news">
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={user2} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>شهروند خبرنگار</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                          {/* </animated.div> */}
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to={`/${4}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={culture} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>رویدادهای فرهنگی</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>
                      </Row>
                    </div>

                    {/* Places */}
                    <div style={Object.assign({}, styles.slide)}>
                      <Row className="justify-content-start">
                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to={`/places/${1}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={place} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>اماکن گردشگری</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink className="rgc-link" to={`/places/${2}`}>
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={religion} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>اماکن مذهبی </h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to="/celebrities">
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={sienticet} alt=".." fluid />
                                </div>

                                <div className="rgc-card-body">
                                  <h6>مشاهیر</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>

                        <Col xs={4} lg={3} className="sub-side mb-3">
                          <NavLink to="/">
                            <div className="rgc-card">
                              <div className="d-flex flex-column rgc-card-img">
                                <div className="rgc-icons">
                                  <Image src={view} alt=".." fluid />
                                </div>
                                <div className="rgc-card-body">
                                  <h6>بازدید مجازی</h6>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </Col>
                      </Row>
                    </div>
                  </SwipeableViews>
                </Col>

                {/* <Col xs={11} lg={9} className="g-0 react-multi-carousel">
                  <div className="d-flex rgc-list-icon text-white">
                    <i class="fa fa-bullhorn text-white"></i>
                    <span>تبلیغات شهری</span>
                  </div>

                  <Carousel
                    className=""
                    responsive={responsive}
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    ssr={true} // means to render carousel on server-side.
                    infinite={false}
                    autoPlay={true}
                    autoPlaySpeed={1000}
                    centerMode={true}
                    arrows={false}
                    rewindWithAnimation={true}
                    rewind={true}
                    shouldResetAutoplay={true}
                    keyBoardControl={true}
                    transitionDuration={500}
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                  >
                    {seenFile.map((data, index) => {
                      return (
                        <div className="rgc-slider mx-3 mx-md-4" key={index}>
                          <img className="rgc-slider-item" src={IPUrl + "UploadedFile/Adv/Ssn/" + data.Img} alt="" />
                          <span>{data.Text}</span>
                        </div>
                      )
                    })}
                  </Carousel>
                </Col> */}
              </Row>
            </Container>
          </div>
        </main>
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Dashboard;
